import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  merchantForm: {
     position: "relative",
  }
}));

export default useStyles;
